<template>
  <div class="page-container">
    <!-- 顶部导航栏 -->
    <el-header class="nav-bar" height="60px">
      <!-- <div class="nav-left">
        <i class="el-icon-arrow-left" @click="goBack" style="cursor:pointer;font-size:20px;"></i>
      </div> -->
      <div class="nav-title">轮播图管理</div>
      <div class="nav-right">
        <el-button type="primary" size="small" @click="showAddModal">新建轮播图</el-button>
      </div>
    </el-header>

    <!-- 主要内容 -->
    <el-main class="content-wrapper">
      <!-- 提示信息 -->
      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom:16px;width: 90%;"
      >
        <template slot="title">
          管理首页轮播图，支持添加、删除和显示/隐藏控制
        </template>
      </el-alert>

      <!-- 列表区域 -->
      <div class="list-container">
        <el-table
          :data="banners"
          v-loading="loading"
          height="57vh"
          style="width:98%"
          border
        >
          <el-table-column label="图片预览" width="140" align="center">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.img"
                fit="cover"
                style="width:80px;height:80px;border-radius:6px;cursor:pointer;"
                :preview-src-list="[scope.row.img]"
              />
            </template>
          </el-table-column>

          <el-table-column label="图片信息" min-width="200">
            <template slot-scope="scope">
              <div>ID: {{ scope.row.id }}</div>
              <div v-if="scope.row.add_time">上传: {{ scope.row.add_time }}</div>
              <div v-else class="url-text">地址: {{ formatShortUrl(scope.row.img) }}</div>
            </template>
          </el-table-column>

          <el-table-column label="是否展示" width="120" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.is_display"
                :active-value="1"
                :inactive-value="0"
                active-color="#1890ff"
                inactive-color="#ccc"
                @change="toggleDisplayStatus(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                @click="deleteBanner(scope.row.id)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 空状态 -->
        <div v-if="!loading && banners.length === 0" class="empty-state">
          <i class="el-icon-picture-outline" style="font-size:80px;color:#ddd;"></i>
          <p style="color:#999;margin-top:12px;">暂无轮播图</p>
          <p style="color:#ccc;font-size:14px;">点击上方“新建轮播图”按钮添加</p>
        </div>

        <!-- 底部刷新按钮 -->
        <div style="margin-top:16px;text-align:right;">
          <el-button type="primary" @click="refreshData" :loading="loading">刷新数据</el-button>
        </div>
      </div>
    </el-main>

    <!-- 新建轮播图弹窗 -->
    <el-dialog
      title="新建轮播图"
      :visible.sync="showModal"
      width="520px"
      @close="resetForm"
      :close-on-click-modal="false"
    >
      <el-form label-width="80px">
        <el-form-item label="是否展示">
          <el-switch v-model="currentBanner.is_display" :active-value="1" :inactive-value="0" />
          <span style="margin-left:10px;font-size:12px;color:#999;">开启后，轮播图将在首页展示</span>
        </el-form-item>

        <el-form-item label="轮播图" required>
          <div class="upload-container">
            <!-- 已有图片预览 -->
            <div v-if="currentBanner.img" class="image-preview">
              <el-image :src="currentBanner.img" fit="cover" style="width:100%;height:180px;" />
              <div class="image-actions">
                <el-button size="mini" @click="chooseImage">重新上传</el-button>
                <el-button size="mini" type="danger" @click="removeImage">删除</el-button>
              </div>
            </div>
            <!-- 上传占位 -->
            <div v-else class="upload-placeholder" @click="chooseImage">
              <i class="el-icon-plus" style="font-size:40px;color:#999;"></i>
              <div style="font-size:14px;color:#999;margin-top:8px;">点击上传图片</div>
            </div>
            <!-- 隐藏的文件选择器 -->
            <input
              type="file"
              ref="fileInput"
              accept="image/*"
              style="display:none;"
              @change="onFileChange"
            />
            <div style="font-size:12px;color:#999;margin-top:6px;">建议尺寸：750x350像素，支持jpg/png格式</div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showModal = false">取消</el-button>
        <el-button type="primary" @click="saveBanner" :loading="saving">
          {{ saving ? '上传中...' : '创建' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import Cookie from 'js-cookie'

const token = Cookie.get('token')
const Request = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})

export default {
  name: 'BannerManagement',
  data () {
    return {
      loading: false,
      saving: false,
      banners: [], // 轮播图列表
      showModal: false,
      currentBanner: {
        img: '',
        is_display: 1
      },
      file: '',
      // top_id 固定为 2（原逻辑保留，但接口未使用）
      topId: '2'
    }
  },
  created () {
    this.loadBanners()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },

    showAddModal () {
      this.currentBanner = { img: '', is_display: 1 }
      this.showModal = true
    },

    resetForm () {
      this.currentBanner = { img: '', is_display: 1 }
      this.saving = false
    },

    // 触发文件选择
    chooseImage () {
      this.$refs.fileInput.click()
    },

    // 文件选择后上传
    onFileChange (e) {
      const file = e.target.files[0]
      console.log(e.target.files[0])
      this.currentBanner.img = URL.createObjectURL(file)
      this.file = e.target.files[0]
      // if (file) {
      //   this.uploadImageToServer(file)
      // }
      // 重置 input，允许重复选择同一文件
      e.target.value = ''
    },

    // 上传图片到服务器（同时创建轮播图记录）
    async uploadImageToServer (file) {
      this.saving = true
      const comlist2 = localStorage.getItem('user_name') ||
                       localStorage.getItem('user_mobile') ||
                       '管理员'

      const formData = new FormData()
      formData.append('file', file)
      // formData.append('top_id', this.topId)   // 原接口注释掉，保留
      formData.append('comlist2', comlist2)
      formData.append('comlist_v5', this.currentBanner.is_display.toString())
      const res = await Request.post('https://caixiao.lianglianyn.com/index/upload_lunbo.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      this.saving = false
      if (res.data.code === 0 && res.data.url) {
        this.currentBanner.img = res.data.url
        this.$message.success('图片上传成功')
        // 关闭弹窗并刷新列表（上传接口已同时创建记录）
        this.showModal = false
        this.loadBanners()
      }
    },

    removeImage () {
      this.currentBanner.img = ''
    },

    formatShortUrl (url) {
      if (!url) return ''
      if (url.length > 30) {
        return url.substring(url.lastIndexOf('/') + 1) || '图片'
      }
      return url
    },

    // 保存（实际上传时已创建，此方法仅做校验并关闭弹窗）
    saveBanner () {
      // if (!this.currentBanner.img) {
      //   this.$message.warning('请上传轮播图')
      //   return
      // }
      this.uploadImageToServer(this.file)
      // 如果图片已上传成功，直接关闭刷新（防止重复提交）
      if (this.saving) return
      this.showModal = false
      this.loadBanners()
    },

    // 切换显示/隐藏
    async toggleDisplayStatus (banner) {
      const newStatus = banner.is_display // 已经通过 v-model 改变
      const originalStatus = newStatus === 1 ? 0 : 1 // 用于回退
      const params = {
        lunbo_id: banner.id,
        comlist_v5: newStatus.toString()
      }
      const res = await Request.post('https://caixiao.lianglianyn.com/index/upload_lunbo_edit.php', params)
      if (res.data.code === 0) {
        this.$message.success(newStatus === 1 ? '已设为展示' : '已设为隐藏')
      } else {
        // 还原状态
        banner.is_display = originalStatus
        this.$message.error(res.data.msg || '修改失败')
      }
    },

    // 删除轮播图
    async  deleteBanner (id) {
      this.$confirm('确定要删除这个轮播图吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          // const token = localStorage.getItem('user_token') || ''
          const comlist2 =
            localStorage.getItem('user_name') ||
            localStorage.getItem('user_mobile') ||
            '管理员'
          const params = { id, comlist2 }
          const res = await Request.post('https://caixiao.lianglianyn.com/include/lunbo_img_del.php', params)
          if (res.data.code === 0) {
            this.$message.success('轮播图已删除')
            this.loadBanners()
          } else {
            this.$message.error(res.data.msg || '删除失败')
          }
        })
        .catch(() => {}) // 取消删除
    },

    refreshData () {
      this.loadBanners()
      this.$message.success('数据已刷新')
    },

    // 加载轮播图列表
    async  loadBanners () {
      this.loading = true
      // const token = localStorage.getItem('user_token') || ''
      const res = await Request.post('https://caixiao.lianglianyn.com/index/new_lunbo_list.php')
      console.log(res)
      if (res.data.code === 0) {
        this.loading = false
        const list = res.data.res || []
        this.banners = list.map((item, idx) => ({
          id: item.id || idx + 1,
          img: item.img,
          is_display: item.comlist_v5 !== undefined ? parseInt(item.comlist_v5) : 0,
          add_time: item.add_time || ''
        }))
      } else {
        this.$message.error(res.data.msg || '获取列表失败')
        this.banners = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 80vh;
  background-color: #f0f2f5;
  display: flex;
  width:100%;
  flex-direction: column;
  overflow: hidden;
}

.nav-bar {
  background-color: #fff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;

  .nav-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
  .nav-left {
    width: 80px;
  }
  .nav-right {
    width: 140px;
    text-align: right;
  }
}

.content-wrapper {
  flex: 1;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.list-container {
  flex: 1;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .el-table {
    flex: 1;
  }

  .empty-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #999;
  }
}

.url-text {
  font-size: 12px;
  color: #aaa;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 上传区域样式 */
.upload-container {
  .image-preview {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    background-color: #f5f5f5;

    .image-actions {
      display: flex;
      justify-content: center;
      gap: 12px;
      padding: 10px 0;
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  .upload-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 180px;
    background-color: #fafafa;
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.2s;

    &:hover {
      border-color: #1890ff;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
